export type AccessMode = (typeof AccessMode)[keyof typeof AccessMode];

export const AccessMode = {
	SUBJECT: "SUBJECT",
	AGENT: "AGENT",
	ADMIN: "ADMIN",
	SYSTEM: "SYSTEM",
	ANONYMOUS: "ANONYMOUS",
} as const;
